// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/create-data-item-request-schema',
  type: 'object',
  required: ['statusId', 'categoryId'],
  properties: {
    title: {
      type: 'string',
      nullable: true,
    },
    subTitle: {
      type: 'string',
      nullable: true,
    },
    comment: {
      type: 'string',
      nullable: true,
    },
    pictureDocumentExternalId: {
      type: 'string',
      nullable: true,
    },
    statusId: {
      type: 'integer',
    },
    validFrom: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    validUntil: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    contentTypeId: {
      type: 'integer',
      nullable: true,
    },
    contentTypeUrl: {
      type: 'string',
      nullable: true,
    },
    contentTypePath: {
      type: 'string',
      nullable: true,
    },
    categoryId: {
      type: 'integer',
    },
    searchTerms: {
      type: 'string',
      nullable: true,
    },
    relatedLinkUrl: {
      type: 'string',
      nullable: true,
    },
    relatedLinkText: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
